import { Drawer, DrawerBody, DrawerHeader, DrawerHeaderTitle, Spinner, makeStyles, tokens } from '@fluentui/react-components'
import { Suspense, useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { SidebarNav } from './Sidebar'
import { TopBar } from './TopBar'
import { useUiStore } from '@/stores/ui'
import { useAuthStore } from '@/stores/auth'
import { usersApi } from '@/api/endpoints'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  sidebar: {
    width: '248px',
    flexShrink: 0,
    backgroundColor: tokens.colorNeutralBackground1,
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0px',
    height: '100%',
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    overscrollBehavior: 'contain',
  },
  footer: {
    padding: '14px 20px',
    textAlign: 'center',
    color: tokens.colorNeutralForeground4,
    fontSize: '12px',
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
  },
})

export default function AppShell() {
  const s = useStyles()
  const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 767px)').matches)
  const { drawerOpen, setDrawerOpen } = useUiStore()
  const { token, user, setUser } = useAuthStore()
  const location = useLocation()

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)')
    const fn = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mq.addEventListener('change', fn)
    return () => mq.removeEventListener('change', fn)
  }, [])

  // 路由变化时关闭移动端抽屉
  useEffect(() => {
    setDrawerOpen(false)
  }, [location.pathname, setDrawerOpen])

  // 有 token 但无用户信息时拉取 profile
  useEffect(() => {
    if (token && !user) {
      usersApi
        .me()
        .then(setUser)
        .catch(() => {
          /* 401 事件已处理 */
        })
    }
  }, [token, user, setUser])

  const nav = (
    <div style={{ height: '100%', width: '248px', backgroundColor: tokens.colorNeutralBackground1 }}>
      <SidebarNav />
    </div>
  )

  return (
    <div className={s.root}>
      {!isMobile && <aside className={s.sidebar}>{nav}</aside>}

      {isMobile && (
        <Drawer
          type="overlay"
          open={drawerOpen}
          onOpenChange={(_, d) => setDrawerOpen(d.open)}
          position="start"
          size="small"
        >
          <DrawerHeader>
            <DrawerHeaderTitle>导航</DrawerHeaderTitle>
          </DrawerHeader>
          <DrawerBody style={{ padding: '0px' }}>{nav}</DrawerBody>
        </Drawer>
      )}

      <div className={s.main}>
        <TopBar onMenuClick={() => setDrawerOpen(true)} />
        <main className={s.content}>
          <Suspense
            fallback={
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '20vh' }}>
                <Spinner label="页面加载中…" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </main>
        <footer className={s.footer}>Idvevent · 第五人格统一赛事管理平台 © 2026</footer>
      </div>
    </div>
  )
}
